import { getFileReader, errorIfNoFileReader } from 'utils/wrappers';
import { showResponseError, showSuccess } from 'utils/messages';

import Base from 'app/views/base';
import tmpl from './template';

const DEFAULT_BUTTON_CLASS = 'btn-primary';

export default Base.extend({
  compiledTemplate: tmpl,

  events: { 'change input.read-file': 'uploadFile' },

  initialize({
    apiModeSelection, callback, buttonText, buttonClass = DEFAULT_BUTTON_CLASS, filename,
  }) {
    this.apiModeSelection = apiModeSelection;
    this.uploading = false;
    this.callback = callback;
    this.buttonText = buttonText;
    this.buttonClass = buttonClass;
    this.filename = filename;
  },

  context() {
    return {
      uploading: this.uploading,
      text: this.buttonText,
      buttonClass: this.buttonClass,
      filename: this.filename,
    };
  },

  uploadFile({ target }) {
    const input = target;

    errorIfNoFileReader(input);

    const file = input.files[0];
    this.readFile(file, data => {
      const self = this;
      self.uploading = true;
      self.render();

      this.callback({
        file,
        data,
        apiModeSelection: this.apiModeSelection,
        success() {
          showSuccess('Your file has been successfully uploaded.');
        },
        error(jqXHR) {
          showResponseError(jqXHR);
        },
        complete() {
          self.uploading = false;
          self.render();
        },
      });
    });
  },

  readFile(file, cb) {
    const reader = getFileReader();
    reader.onload = event => {
      const csvData = event.target.result;
      cb(csvData);
    };
    reader.readAsText(file);
  },
});



// WEBPACK FOOTER //
// ./app/components/upload_file_button/index.js